<template>
  <div class="flex items-center">
    <vx-tooltip position="top"
                title="Index does not exist yet"
                :text="tooltipText"
                class="flex items-center"
                :enabled="true"
    >
      <span class="text-gray-dark">Never indexed ⚠️</span>
    </vx-tooltip>
  </div>
</template>

<script>
export default {
  name: 'IndexExecutionWarning',
  props: {
    hasScheduleParams: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tooltipText() {
      return this.hasScheduleParams ?
        'Index will exist after the scheduled indexation.' :
        'To create the index in the future:<br/>• enable "Repeated updates"<br/>To create the index now:<br/>• click "Reindex now"'
    }
  }
}
</script>
